import { render } from "./PageBlockComponent.vue?vue&type=template&id=e0b8c454&ts=true"
import script from "./PageBlockComponent.vue?vue&type=script&lang=ts"
export * from "./PageBlockComponent.vue?vue&type=script&lang=ts"

import "./PageBlockComponent.vue?vue&type=style&index=0&id=e0b8c454&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__